import styled from 'styled-components';

import { body } from '@constants/fonts';

export const RecordTimelineBlockDiv = styled.div`
  display: flex;
  width: 94%;
  flex-direction: column;
  margin-bottom: 20px;
  margin-left: 11px;
  font-size: 14px;
  font-weight: 500;
`;

export const RecordTimelineDate = styled.div<{
  flexEnd?: boolean;
}>`
  display: flex;
  width: max-content;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.palette.error.light};
  color: ${({ theme }) => theme.palette.secondary.main};
  height: 30px;
  margin-bottom: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding: 0 20px;
  font-weight: 700;
  font-size: 14px;
  font-family: ${body};
  align-self: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
`;

export const LocationH2 = styled.h2`
  font-size: 14px;
  font-weight: normal;
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 5px 0 5px 5px;
  line-height: 16px;
`;

export const LocationH2Icon = styled.div`
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin: 0 0 5px 0;
`;
